// Miroir exact de QuizService.computePoints() côté back
// Points = basePoints × (1 + timeRemaining / timeTotal)
// réponse instantanée → ×2.0 | dernière seconde → ×1.1 | timeout → 0
export const computeQuizPoints = (basePoints, timeLimitSec, timeTakenMs) => {
    const timeLimitMs = timeLimitSec * 1000;
    if (timeTakenMs == null || timeTakenMs >= timeLimitMs) return 0;
    const multiplier = 1.0 + (timeLimitMs - timeTakenMs) / timeLimitMs;
    return Math.trunc(basePoints * multiplier); // toInt() Kotlin = trunc côté JS
};
